/**
 * Cores dos graficos do painel de SMS.
 *
 * Validadas com o script do dataviz nos dois temas: separacao de 31,9 em
 * visao normal e contraste acima de 3:1 sobre a superficie do card.
 *
 * "Na fila" NAO ganha cor de status de proposito. Nao e' um aviso — e' ausencia
 * de desfecho, a operadora ainda nao respondeu. Pintar de ambar sugeriria
 * problema onde nao ha, e ambar contra vermelho ficava indistinguivel
 * (delta 11,8, abaixo do piso de 15 para visao normal).
 *
 * Cor de status nunca aparece sozinha: toda legenda traz rotulo e valor.
 */
export const STATUS = {
  entregue: { cor: "#0E9F6E", rotulo: "Entregue" },
  falha: { cor: "#EF4444", rotulo: "Não entregue" },
  fila: { cor: "currentColor", rotulo: "Na fila", neutro: true },
};

/** Serie unica de magnitude (ranking). */
export const ACENTO = "#5F82F0";
